import React, { useState,useRef,useEffect } from 'react';
import {ReactComponent as ReactLogo} from '../reshot-icon-bold-right-arrow-STPW6DFVRY-7b0db.svg';


const QuestionsBlock=()=> {
	const questions = [
		{
			questionText: 'Are you a local or international student?',
			answerOptions: [
				{ answerText: 'Local', isCorrect: "A"},
				{ answerText: 'International', isCorrect: "B"},
			],
		},
		{
			questionText: 'Which programme do you intend to pursue?',
			answerOptions: [
				{ answerText: 'Pre-university (AUSMAT, A-Level, CIMP, MUFY, FIA, FIST, ACCA-FIA, CFAB, Diploma, ADTP)', isCorrect: "A"},
				{ answerText: 'Degree', isCorrect:"B" },
				{ answerText: 'Professional Accounting', isCorrect: "C" },
				{ answerText: 'Post graduate', isCorrect: "D"},
			],
		},
		{
			questionText: 'Do you have a certified talent(sports, music, culinary etc.)?',
			answerOptions: [
				{ answerText: 'Yes', isCorrect: "A" },
				{ answerText: 'No', isCorrect: "B" },

			],
		},
		{
			questionText: 'Are you actively involved in extracurriculars?',
			answerOptions: [
				{ answerText: 'Yes', isCorrect: "A" },
				{ answerText: 'No', isCorrect: "B" },
			],
		},{
			questionText: 'Household Income ',
			answerOptions: [
				{ answerText: '<= RM 2000', isCorrect: "A"},
				{ answerText: '<= RM 5000', isCorrect: "B" },
				{ answerText: 'None of the above', isCorrect: "C" },
			],
		},
	];


	const eligibility=[[["AAAAA"],["AAABA"]],
	[["AAAAC"], ["AAABC"]],
	[["AAAAB"], ["AAABB"]],
	[["AABAA"], ["AABBA"]],
	[["AABAB"], ["AABBB"]],
	[["AABAC"], ["AABBC"], ["BABAA"], ["BABAB"], ["BABAC"], ["BABBA"], ["BABBB"], ["BABBC"], ["BCAAA"], ["BCAAB"], ["BCAAC"], ["BCABA"], ["BCABB"], ["BCABC"], ["BCBAA"], ["BCBAB"], ["BCBAC"], ["BCBBA"], ["BCBBB"], ["BCBBC"]],
[["ABAAA"]],
[["ABAAB"]],
[["ABAAC"]],
[["ABABA"]],
[["ABABB"]],
[["ABABC"]],
[["ABBAA"]],
[["ABBAB"]],
[["ABBAC"]],
[["ABBBA"]],
[["ABBBB"]],
[["ABBBC"], ["BBBAA"], ["BBBAB"], ["BBBAC"], ["BBBBA"], ["BBBBB"], ["BBBBC"]],
[["ACAAB"], ["ACABB"], ["ACBAB"], ["ACBBB"]],
[["ACAAC"], ["ACBAC"], ["ACBBC"],["ACABC"]],
[["ACABA"], ["ACBAA"], ["ACBBA"],["ACAAA"]],
[["ADAAA"], ["ADAAB"], ["ADAAC"], ["ADABA"], ["ADABB"], ["ADABC"], ["ADBAA"], ["ADBAB"], ["ADBAC"], ["ADBBA"], ["ADBBB"], ["ADBBC"],["BDAAA"], ["BDAAB"], ["BDAAC"], ["BDABA"], ["BDABB"], ["BDABC"], ["BDBAA"], ["BDBAB"], ["BDBAC"], ["BDBBA"], ["BDBBB"], ["BDBBC"]],
[["BAAAA"], ["BAAAB"], ["BAAAC"], ["BAABA"], ["BAABB"], ["BAABC"]],
[["BBAAA"], ["BBAAB"], ["BBAAC"], ["BBABA"], ["BBABB"], ["BBABC"]]]
	const scholarshipList ={0:["Jeffrey Cheah Entrance Scholarship", "Sunway Sports Scholarship","Sunway College - STYLO Fashion Design Technology Hub Talent Scholarship", "Sunway University Young Chef Scholarship", "Sunway University Art and Design Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
1:["Jeffrey Cheah Entrance Scholarship", "Sunway Sports Scholarship", "Sunway College - STYLO Fashion Design Technology Hub Talent Scholarship", "Sunway University Young Chef Scholarship", "Sunway University Art and Design Scholarship"],
2:["Jeffrey Cheah Entrance Scholarship", "Sunway Sports Scholarship", "Sunway College - STYLO Fashion Design Technology Hub Talent Scholarship", "Sunway University Young Chef Scholarship", "Sunway University Art and Design Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
3:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
4:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
5:["Jeffrey Cheah Entrance Scholarship"],
6:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Sunway Sports Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship", "The Chancellors Scholarship of Sunway University and Lancaster University", "Sunway University Excellence Scholarship", "Sunway-Victoria University Excellence Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
7:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Sunway Sports Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship", "The Chancellors Scholarship of Sunway University and Lancaster University", "Sunway University Excellence Scholarship", "Sunway-Victoria University Excellence Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
8:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Sunway Sports Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship", "The Chancellors Scholarship of Sunway University and Lancaster University", "Sunway University Excellence Scholarship", "Sunway-Victoria University Excellence Scholarship"],
9:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Sunway Sports Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
10:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Sunway Sports Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
11:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Sunway Sports Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship"],
12:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "The Chancellors Scholarship of Sunway University and Lancaster University", "Sunway University Excellence Scholarship", "Sunway-Victoria University Excellence Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
13:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "The Chancellors Scholarship of Sunway University and Lancaster University", "Sunway University Excellence Scholarship", "Sunway-Victoria University Excellence Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
14:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "The Chancellors Scholarship of Sunway University and Lancaster University", "Sunway University Excellence Scholarship", "Sunway-Victoria University Excellence Scholarship"],
15:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
16:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
17:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship"],
18:["Jeffrey Cheah Entrance Scholarship", "Sunway-ICEAW Global Accountant Scholarship Scheme", "Sunway-ACCA Global Leader Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
19:["Jeffrey Cheah Entrance Scholarship", "Sunway-ICEAW Global Accountant Scholarship Scheme", "Sunway-ACCA Global Leader Scholarship"],
20:["Jeffrey Cheah Entrance Scholarship", "Sunway-ICEAW Global Accountant Scholarship Scheme", "Sunway-ACCA Global Leader Scholarship", "Jeffrey Cheah Foundation Community Scholarship", "Jeffrey Cheah Foundation Scholarship", "Sunway TFM Scholarship", "SEG-Elena Cooke Education Fund", "The Star Education Fund", "Sin Chew Daily Education Fund"],
21:["Sunway University Taught Masters Scholarship", "SHSM Service Industry Scholarship for Postgraduate Studies"],
22:["Jeffrey Cheah Entrance Scholarship", "Sunway College - STYLO Fashion Design Technology Hub Talent Scholarship", "Sunway University Young Chef Scholarship", "Sunway University Art and Design Scholarship"],
23:["Jeffrey Cheah Entrance Scholarship", "Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship", "Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music", "Sunway Music Scholarship", "Sunway University Art and Design Scholarship"]}

const linkList={
"Jeffrey Cheah Entrance Scholarship":"https://www.sunway.edu.my/scholarships/scholarships-awards/jeffrey-cheah-entrance-scholarship",
"Sunway University Taught Masters Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-university-taught-masters-scholarship",
"Sunway Sports Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-sports-scholarship",
"Jeffrey Cheah Foundation Community Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/jeffrey-cheah-foundation-community-scholarship",
"Jeffrey Cheah Foundation Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/jeffrey-cheah-foundation-scholarship",
"Jeffrey Cheah Advance and Continuing Excellence (ACE) Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/jeffrey-cheah-ace-scholarship",
"Sunway-ICEAW Global Accountant Scholarship Scheme": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-icaew-accountant-scholarship",
"SHSM Service Industry Scholarship for Postgraduate Studies": "https://www.sunway.edu.my/scholarships/scholarships-awards/SHSM-scholarship",
"Sunway College - STYLO Fashion Design Technology Hub Talent Scholarship":"https://www.sunway.edu.my/scholarships/scholarships-awards/STYLO-talent-scholarship",
"Sunway TFM Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-teach-malaysia-scholarship",
"The Chancellors Scholarship of Sunway University and Lancaster University": "https://www.sunway.edu.my/scholarships/scholarships-awards/chancellors-scholarship-sunway-university-and-lancaster-university",
"Sunway-ACCA Global Leader Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-acca-global-leadership-scholarship",
"Sunway University Young Chef Scholarship":
"https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-university-young-chef-scholarship",
"SEG-Elena Cooke Education Fund": "https://www.sunway.edu.my/scholarships/scholarships-awards/elena-cooke-education-fund",
"Tun Dr Siti Hasmah Mohd Ali Scholarship for Creative Art and Music": "https://www.sunway.edu.my/scholarships/scholarships-awards/siti-hasmah-scholarship",
"Sunway University Excellence Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-excellence-scholarship",
"Sunway University Art and Design Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-university-art-and-design-scholarship",
"Sunway Music Scholarship": "https://www.sunway.edu.my/scholarships/scholarships-awards/sunway-music-scholarship",
"Sunway-Victoria University Excellence Scholarship":
"https://www.sunway.edu.my/scholarships/scholarships-awards/victoria-university-excellence-award",
"The Star Education Fund":"https://www.sunway.edu.my/scholarships/scholarships-awards/the-star-education-fund",
"Sin Chew Daily Education Fund":"https://www.sunway.edu.my/scholarships/scholarships-awards/sin-chew-education-fund "


}


// 	useEffect(()=>{ if(nextQuestion===questions.length){
	
// }

// 	}
// 	)
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [output, setOutput] = useState(0);
	const [list, setList] = useState([]);
	const [start,setStart] = useState(false);
	const [allow,setAllow]=useState(false);
	let nextQuestion;
	let no;
	const count = useRef();
	count.current=list;
	
	useEffect(() => {
		if(list.length === 5){
			console.log(nextQuestion+"This is nextq")
			let sample=list.toString();
			console.log(sample)
			let newSample = sample.replaceAll(",","")
			console.log(newSample)
		loop1: for (let i = 0; i < eligibility.length; i++) {
			console.log(i)
			for (let j = 0; j < eligibility[i].length; j++) {
				console.log("This is J "+ eligibility[i][j])
				console.log(eligibility[i][j][0])
				if(eligibility[i][j][0]===newSample){
					console.log("We're here")
					no = i;
					break loop1;
				}
			}
		}
		console.log(list)
		console.log("This is "+ no)
		console.log("This has been set")
		console.log(scholarshipList[no])
		setOutput(scholarshipList[no])
		console.log("This is the object number "+no)}
		
	},[list])
	
	
	
	
	
	const previousQuestion = ()=>{
		console.log(allow)
		if(currentQuestion >=1 && allow===true){
			const nextQuestion= currentQuestion-1;
			setCurrentQuestion(nextQuestion)
			if(list.length>=1){
				console.log(nextQuestion+"List pop just happened")
				setList(list=>list.slice(0, -1))
			} 
			console.log("list pop did not happen")
		} else if(currentQuestion===4 && allow===false){
			setAllow(true)
			console.log(allow)
			if(list.length>=1){
				console.log(currentQuestion+"List pop just happened")
				setList(list=>list.slice(0, -1))
			} 
		}
	}

	const restart=()=>{
		setStart(false);
		setList(list=>[])
		nextQuestion=0;
		setCurrentQuestion(nextQuestion)

	}
	
	const handleStartClick =()=>{
		setStart(true)

	}

	const handleAnswerOptionClick = (id) => {
		console.log(id)
		setList(list=>[...list,id]);
		console.log(list)
		
		
		nextQuestion = currentQuestion + 1;
		if (nextQuestion < questions.length) {
			setCurrentQuestion(nextQuestion);
			
		} else {
			nextQuestion =currentQuestion+ 1;
								}}


		let ques = questions[currentQuestion].answerOptions.map((answerOption) => (
			<button onClick={() => handleAnswerOptionClick(answerOption.isCorrect)}>{answerOption.answerText}<ReactLogo /></button>
		))

		let prev = <button onClick={()=>previousQuestion()}><ReactLogo className="Test"/>Back</button>
		let prev2= 	<button onClick={()=>restart()}><ReactLogo className="Test"/>Back</button>


			const final = <>
			{output? 
			(
			<>
			<div className='question-section'>
				<div className='question-count'>
				<button onClick={()=>previousQuestion()}><ReactLogo className="Test"/>Back</button>
					<span>Here are all the scholarships you are eligible for:</span>
					<ul>
					{output.map((outputs)=>(<li className="links"><a  target="_blank" href={linkList[outputs]}>{outputs}</a></li>))}
					</ul>
				</div>
				<div className='question-text'></div>
			</div>
			<div className='answer-section'>
				<button><a target="_blank" href="https://www.sunway.edu.my/scholarships">Click here for more information</a></button>
			</div>
			</>)
		:(<>
		</>)}
		
		</> 

	
	return (
		<div className='main'>
			{!start? (
				<div className="logos">
				<ul className="socials">
						<li>
						<a  href="https://susc.carrd.co/" >
						<img className="logo logo-1" src={require('../SUSC.png')} alt="Scholarship website" />
							</a>
						</li>
						<li>
						<a  href="https://linktr.ee/sunwayssa" >
						<img className="logo logo-2" src={require('../SSA-Logo-Dark.png')} alt="Instagram" />
							</a>
						</li>
					</ul>
				</div>):(<></>)
			}
		<div className='app'>
			{start ? (
				<>
				{list.length<5?
					<div className='question-section'>
						<div className='question-count'>
							{list.length===0 || list.length ===5?prev2:prev}
							<span>Question {currentQuestion + 1}</span>/{questions.length}
						</div>
						<div className='question-text'>
							{questions[currentQuestion].questionText}
						</div>
					</div>
                      :<></>}
					<div className='answer-section'>
						{list.length===5 ? final : ques}
					</div>
				</>)
		: <>
		<div className='question-section'>

				<p className="title">SUSC X SSA</p>

				<h1 className="welcome">Welcome to the Scholarships Quiz!</h1>
				<p className="prompt">Learn about all the scholarships you are eligible for!</p>
				<div className='answer-section'>

				<button onClick={()=>handleStartClick()}>Let's Start!<ReactLogo /></button>
				</div>
		</div>
		</>}
			
		</div>
		{!start? (
		<div className="test">
				<ul className="socials">
					<li className="social-link">
					<a  href="https://www.sunway.edu.my/scholarships" >
					<img className="icon" src={require('../home-svgrepo-com.png')} alt="Scholarship website" />
						</a>
					</li>
					<li className="social-link">
					<a  href="https://www.instagram.com/sl_sunway/" >
					<img className="icon" src={require('../instagram-svgrepo-com.png')} alt="Instagram" />
						</a>
					</li>
					<li className="social-link">
					<a  href="https://www.facebook.com/SunwayStudentLIFE/" >
					<img className="icon" src={require('../facebook-svgrepo-com.png')} alt="Facebook" />
						</a>
					</li>
					<li className="social-link">
					<a  href="mailto:scholarship@sunway.edu.my" >
					<img className="icon" src={require('../mail-svgrepo-com.png')} alt="Email" />
						</a>
					</li>
				</ul>
				</div>):(<></>)}
		</div>
	);
}


export default QuestionsBlock;